import React from 'react';
import { Box, Typography, Grid, Divider, Chip } from '@mui/material';
import { CheckCircle, Cancel } from '@mui/icons-material';

const ModalDetalleRespuestas = ({ data, esEncuesta }) => {
    const preguntas = data || [];

    if (preguntas.length === 0) {
        return (
            <Typography align="center" variant="subtitle1">
                No se encontraron respuestas registradas.
            </Typography>
        );
    }

    return (
        <Box>
            {preguntas.map((pregunta, index) => (
                <Box key={pregunta.idPregunta} sx={{ mb: 3 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                        {index + 1}. {pregunta.npregunta}
                    </Typography>

                    {pregunta.esAbierta ? (
                        <Box sx={{ pl: 2, py: 1, backgroundColor: '#f5f5f5', borderRadius: 1 }}>
                            <Typography variant="body2">{pregunta.respuestaTexto || 'Sin respuesta registrada'}</Typography>
                        </Box>
                    ) : (
                        <Grid container spacing={1}>
                            {pregunta.opciones?.map((opcion) => {
                                const esSeleccionada = Number(opcion.seleccionada) === 1;
                                const esCorrectaOpcion = Number(opcion.isCorrecta) === 1;

                                let backgroundColor = '#f5f5f5';
                                let border = 'none';
                                let icono = null;

                                if (!esEncuesta) {
                                    if (esCorrectaOpcion) backgroundColor = '#c8e6c9';
                                    if (esSeleccionada) {
                                        border = esCorrectaOpcion ? '2px solid #4caf50' : '2px solid #f44336';
                                        if (!esCorrectaOpcion) backgroundColor = '#ffcdd2';
                                        icono = esCorrectaOpcion ? (
                                            <CheckCircle color="success" fontSize="small" />
                                        ) : (
                                            <Cancel color="error" fontSize="small" />
                                        );
                                    }
                                } else {
                                    if (esSeleccionada) {
                                        border = '2px solid #2196f3';
                                        backgroundColor = '#bbdefb';
                                    }
                                }

                                return (
                                    <Grid item xs={12} sm={6} key={opcion.idRespuesta}>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 1,
                                                p: 1,
                                                borderRadius: 1,
                                                backgroundColor,
                                                border
                                            }}
                                        >
                                            {icono}
                                            <Typography variant="body2">{opcion.nrespuesta}</Typography>
                                            {!esEncuesta && esCorrectaOpcion && !esSeleccionada && (
                                                <Chip label="Correcta" size="small" color="success" sx={{ ml: 'auto' }} />
                                            )}
                                        </Box>
                                    </Grid>
                                );
                            })}
                        </Grid>
                    )}
                    <Divider sx={{ mt: 2 }} />
                </Box>
            ))}
        </Box>
    );
};

export default ModalDetalleRespuestas;
